import type {
  BillingWorkflowSelfServeCommandRequestBodyType,
  BillingWorkflowSelfServeCommandResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { api } from "../api";
import { billingWorkflowKeys } from "../queryKeys";

export type {
  BillingWorkflowSelfServeCommandRequestBodyType,
  BillingWorkflowSelfServeCommandResponseBodyType,
} from "@intelligems/ig-types";

type HandleSelfServeCommandOptions = Omit<
  UseMutationOptions<
    BillingWorkflowSelfServeCommandResponseBodyType,
    Error,
    BillingWorkflowSelfServeCommandRequestBodyType
  >,
  "mutationFn" | "mutationKey"
>;

export const handleSelfServeCommand = async (
  body: BillingWorkflowSelfServeCommandRequestBodyType
): Promise<BillingWorkflowSelfServeCommandResponseBodyType> => {
  const resp = await api.post<
    BillingWorkflowSelfServeCommandResponseBodyType,
    BillingWorkflowSelfServeCommandRequestBodyType
  >("/v2/billing-workflow/self-serve", body);

  return resp.data;
};

export const useHandleSelfServeCommand = (
  options?: HandleSelfServeCommandOptions
) =>
  useMutation<
    BillingWorkflowSelfServeCommandResponseBodyType,
    Error,
    BillingWorkflowSelfServeCommandRequestBodyType
  >({
    ...options,
    mutationKey: billingWorkflowKeys.selfServeCommand,
    mutationFn: handleSelfServeCommand,
  });
